 // app/javascript/controllers/index.js
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./../application"

// Optional: for debugging in the console
window.application = application

// Hris Form
import EndDateController from "./end_date_controller"
import DesignationFieldController from "./designation_fields_controller"
import NestedFormController from "./nested_form_controller"
import MaritalStatusController from "./marital_status_controller"
import DepartmentDesignationController from "./department_designation_controller"
import DepartmentManagersController from "./department_managers_controller"
import SalaryFormController from "./salary_form_controller"
import UploadPreviewController from "./upload_preview_controller"

application.register("end-date", EndDateController)
application.register("designation-field", DesignationFieldController)
application.register("nested-form", NestedFormController)
application.register("marital-status", MaritalStatusController)
application.register("department-designation", DepartmentDesignationController)
application.register("department-managers", DepartmentManagersController)
application.register("salary", SalaryFormController)
application.register("upload-preview", UploadPreviewController)
